<template>
  <div class="ls-service-event-item-header--wrapper">
    <div class="header-text" :class="{ hover: hover }">
      <div class="header-text--top">
        <LsIcon
          v-if="isQuote"
          type="quote"
          :color="color"
          :size="screenSize.desktop ? 'sm' : 'xlg'"
          style="margin-right: 5px;"
        />
        <h4 :class="['service-name', color, { hover: hover }]">{{ serviceName }}</h4>
        <p v-if="serviceFrequency">{{ t(serviceFrequency) || serviceFrequency }}</p>
      </div>
      <p v-if="serviceScope" class="header-text--scope">{{ serviceScope }}</p>
    </div>
    <LsIcon
      v-if="!isQuote && !enableQuickActions"
      type="chevron"
      :color="`${color}${hover ? '-dark' : ''}`"
      size="md"
    />
    <LsServiceItemQuickActions v-else-if="enableQuickActions" :schedule="schedule" />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsIcon } from '@/components/common';
import { mapState } from 'vuex';
import { lsPropTypeHelpers } from 'ls-vue-common';
import LsServiceItemQuickActions from '../LsServiceItemQuickActions/LsServiceItemQuickActions.vue';

export default {
  name: 'LsServiceEventItemHeader',
  components: {
    LsIcon,
    LsServiceItemQuickActions,
  },
  props: {
    schedule: VueTypes.object,
    serviceName: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
    serviceFrequency: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
    serviceScope: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
    isQuote: VueTypes.bool.def(false),
    enableQuickActions: VueTypes.bool.def(false),
    hover: VueTypes.bool.def(false),
    color: VueTypes.string.def('primary'),
  },
  computed: {
    ...mapState(['screenSize']),
  },
};
</script>

<style lang="scss" scoped>
.ls-service-event-item-header--wrapper {
  position: relative;
  font-size: $size-3;
  padding-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $primary;

  .header-text--top {
    display: flex;
    align-items: center;
  }

  .header-text--scope {
    font-style: italic;
  }

  .service-name {
    padding-right: 4px;
    font-weight: 700;
  }

  .danger {
    color: $danger;
  }

  .hover {
    color: $primary-dark !important;
  }
}

.themed-app {
  .ls-service-event-item-header--wrapper {
    font-size: var(--theme-txt-title-sm);
    color: $theme-color-primary;
    .hover {
      color: $theme-color-primary-hover !important;
    }
  }
}
</style>
